import { IAppState } from '../../../../../AppModulesWrapper';
import { selectAuctionBet } from './selectAuctionBet';

export function selectCurrentBet(state: IAppState): number {
  const auctionBet = selectAuctionBet(state);

  return auctionBet.value;
}
